import React from 'react';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './ForemanHeader.css';
import logo from '../../../img/logo.png';
import { showStats } from '../../../reducers/currentUser/currentUser.reducer';

export const ForemanHeader = () => (
  <Navbar staticTop >
    <Navbar.Header>
      <Navbar.Brand>
        <a href="/foreman" ><img src={logo} alt="logo" className="logo" /> Foreman</a>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse>
      <Nav pullLeft >
        <LinkContainer to="/foreman" ><NavItem>DWRs</NavItem></LinkContainer>
        <LinkContainer to="/foreman/history" ><NavItem>History</NavItem></LinkContainer>
        {showStats() && <LinkContainer exact to="/foreman/stats" ><NavItem>Stats</NavItem></LinkContainer>}
        <LinkContainer to="/logout" ><NavItem>Logout</NavItem></LinkContainer>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);



// WEBPACK FOOTER //
// ./src/components/Foreman/Header/ForemanHeader.jsx